import { Link, NavLink } from 'react-router-dom'
import { Stack, TableCell, TableRow, Typography } from '@mui/material'
import { formatBigMoney, formatDateYYYYMMDD } from '../../../../packages/utils/numberFormatters'
import React from 'react'
import { getSubPriceLabel } from '../../../../utils/issues/getSubPriceLabel'
import IssueTypeLabels from '../../../../components/entities/IssueTypeLabels'
import { IssueEntity } from 'types/IssueEntity'

type IssueObject = {
    type: 'issue'
    subStartDate: string
    subEndDate: string
    item: IssueEntity
}

const issueTypeLabel = (type: string) => {
    switch (type) {
        case 'Rights issue':
            return 'Företrädesemission'
        case 'Directed issue':
            return 'Riktad emission'
        case 'Non-cash issue':
            return 'Apportemission'
        case 'IPO':
            return 'IPO'
        case 'Guarantor fee issue':
            return 'Garantieemission'
        case 'ABB Directed issue':
            return 'Accelererad bookbuilding'
        default:
            return type
    }
}

export function IssueTableRow({
    obj,
    locale,
    isLargeScreen,
    multipleInstrumentsExists = false,
}: {
    obj: IssueObject
    locale: string
    isLargeScreen: boolean
    multipleInstrumentsExists: boolean
}) {
    const issue = obj.item

    const subPriceLabel = getSubPriceLabel({ issue, locale, excludeCurrency: true })

    return (
        <TableRow>
            {multipleInstrumentsExists && isLargeScreen ? <TableCell>{issue.instrumentSymbol}</TableCell> : null}
            <TableCell>
                <Stack direction={{ sx: 'column', sm: 'row' }} spacing={2} alignItems={{ xs: 'start', sm: 'center' }}>
                    <IssueTypeLabels issue={issue} />
                    {issue.type === 'Guarantor fee issue' ? issueTypeLabel(issue.type) : null}
                    {issue.type !== 'Guarantor fee issue' ? (
                        <Link component={NavLink} to={`/issues/${issue.id}`}>
                            {issueTypeLabel(issue.type)}
                            {issue.type === 'Non-cash issue' && ` (${issue.noncashConsideration})`}
                        </Link>
                    ) : null}
                </Stack>
            </TableCell>
            <TableCell>
                {issue.type === 'Rights issue'
                    ? `${formatDateYYYYMMDD(issue.subStartDate)} - ${formatDateYYYYMMDD(issue.subEndDate)}`
                    : formatDateYYYYMMDD(obj.subStartDate)}
            </TableCell>
            <TableCell>{subPriceLabel}</TableCell>
            {isLargeScreen ? (
                <TableCell>
                    <Typography>
                        {issue.totalUnitSize !== null
                            ? formatBigMoney(issue.totalUnitSize, { locale, currencySymbol: issue?.currency })
                            : null}
                    </Typography>
                </TableCell>
            ) : null}
        </TableRow>
    )
}
